import ButtonDefault from 'ui/src/buttons/ButtonDefault'
import ModalDefault from '@/components/parts/modal/ModalDefault'
import TableModalPasswordEdit from '@/components/partsGroups/tables/TableModalPasswordEdit'
import { useLocale } from '@/features/i18n/hooks/useLocale'

interface Props {
  className?: string
  isOpen?: boolean
  onClose?: () => void
}

export default function ModalPasswordEdit({ className, isOpen, onClose }: Props) {
  const { t } = useLocale()

  return (
    <ModalDefault title={t.header.EditPassword} isOpen={isOpen} onClose={onClose}>
      <TableModalPasswordEdit isOpen={isOpen} onClose={onClose} />
    </ModalDefault>
  )
}
